import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, TagList, TagSelect } from '@piplapps/pipl-ui';
import styles from './RemoveUserModal.module.less';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import { UsersSelectors } from '../../../../Redux/modules/users/selectors';
import LoadingButton from '../../../../Components/LoadingButton';
import AnalyticsHandler from '../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const BulkAssignToTeamsModal = (props) => {
  const usersItems = props.selectedUsers.map((userRow) => {
    return { label: userRow.original?.email, value: userRow.original?.id };
  });

  const getCommonTeamsIds = () => {
    const commonTeamsIds = [];
    const teamUsersList = {};
    for (const team of props.teams) {
      teamUsersList[team.id] = [];
    }
    for (const user of props.selectedUsers) {
      const userTeams = user.original.teams;
      for (const team of userTeams) {
        teamUsersList[team.id].push(user.original.id);
      }
    }
    for (const [team_id, user_ids] of Object.entries(teamUsersList)) {
      if (user_ids.length === props.selectedUsers.length) {
        commonTeamsIds.push(parseInt(team_id, 10));
      }
    }
    return commonTeamsIds;
  };

  const [itemsToAssign, setItemsToAssign] = useState(usersItems);
  const [teams, setTeams] = useState(getCommonTeamsIds());
  const [teamsNames, setTeamsNames] = useState([]);

  const teamOptions = props.teams?.map((team) => {
    return { label: team.name, value: team.id.toString() };
  });

  const handleAssignUsers = () => {
    const usersIdsToAssign = itemsToAssign.map((item) => item.value);
    const teamsToUnassign = getCommonTeamsIds().filter((teamId) => !teams.includes(teamId));
    props.assignUsersToTeams({ users: usersIdsToAssign, teams, teamsToUnassign });
  };

  return (
    <div className={styles.modalContainer}>
      <span tabIndex={0} role="button" className={styles.close} onClick={() => props.clickedCloseModalButton()}>
        &times;
      </span>
      <div className={styles.header}>{gettext('Assign team')}</div>
      <div className={styles.usersContainer}>
        <TagList
          items={itemsToAssign}
          icon={<span className={styles.closeTag}>X</span>}
          onClick={(e) => {
            setItemsToAssign(itemsToAssign.filter((item) => item.value !== parseInt(e.currentTarget.id, 10)));
          }}
        />
      </div>
      <div className={styles.inputWrapper}>
        <div className={styles.inputWrapper}>
          <TagSelect
            options={teamOptions}
            name="teamsSelect"
            id="teamsSelect"
            testId="teamsSelect"
            onChange={(value) => {
              setTeams(value.map((team) => parseInt(team.value, 10)));
              setTeamsNames(value.map((team) => team.label));
            }}
            values={teams.map((team) => team.toString())}
            label={gettext('Select team')}
            isSearchable={false}
            emptyChoicesText={gettext('No team is assigned')}
            tagsCaption={teams.length > 1 ? gettext('Selected teams') : gettext('Selected team')}
            tagsCaptionClassName={styles.tagsCaption}
            closeMenuOnSelect
          />
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <div className={styles.buttonUpdate}>
          <AnalyticsHandler
            eventName={AnalyticsEventNames.BULK_ASSIGN_TO_TEAMS}
            eventData={{
              manipulatedUsers: itemsToAssign.map((item) => item.value).toString(),
              manipulatedUsersEmails: itemsToAssign.map((item) => item.label).toString(),
              teams: teamsNames,
            }}
          >
            <LoadingButton
              buttonClass="primary-blue"
              type="submit"
              text={gettext('Save')}
              width="39%"
              loadingText={gettext('Saving')}
              onClick={() => handleAssignUsers()}
              id="submit-button"
              disabled={itemsToAssign.length === 0}
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonCancel}>
          <Button
            buttonClass="secondary-blue"
            onClick={() => props.clickedCloseModalButton()}
            text={gettext('Cancel')}
          />
        </div>
      </div>
    </div>
  );
};

BulkAssignToTeamsModal.propTypes = {
  clickedCloseModalButton: PropTypes.func,
  teams: PropTypes.array,
  selectedUsers: PropTypes.array,
  assignUsersToTeams: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    modalError: UsersSelectors.modalErrorSelector(state),
    modalErrorMessage: UsersSelectors.modalErrorMessageSelector(state),
    teams: UsersSelectors.teamsSelector(state),
  };
};

const mapDispatchToProps = {
  onAssignToTeams: UsersActions.assignToTeams,
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
  assignUsersToTeams: UsersActions.bulkAssignToTeams,
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkAssignToTeamsModal);
